"use client";

import { Card, CardContent, CardHeader, cn } from "@saridana-core/react-ui-kit";
import { TIconTitleDescription, TOurValuesSection } from "@shared/types";
import { SectionHeading } from "@shared/ui";
import Image from "next/image";

function OurValueItem({ title, icon, description }: TIconTitleDescription) {
  return (
    <Card className={cn("text-white border-0 shadow-none h-full flex flex-col justify-between bg-transparent")}>
      <div>
        {icon && icon.data && (
          <CardHeader className="p-0 mb-6 sm:mb-8 bg-white flex items-center justify-center text-center rounded-xl size-[68px] mx-auto md:mx-0">
            <Image
              src={icon.data?.attributes?.url || ""}
              width={icon.data?.attributes?.width || 36}
              height={icon.data?.attributes?.height || 36}
              alt={icon.data?.attributes?.alternativeText || icon.data?.attributes?.name || ""}
              className="size-9"
            />
          </CardHeader>
        )}
        <CardContent className="p-0 text-center md:text-left">
          <h4 className="font-bold text-[28px] leading-[140%]">{title}</h4>
          {description && <p className="mt-2 sm:mt-4 font-normal text-lg leading-[146%]">{description}</p>}
        </CardContent>
      </div>
    </Card>
  );
}

export function OurValuesSection({ title, description, list, ornament }: TOurValuesSection) {
  return (
    <section
      className="text-white py-20 sm:py-[100px] lg:py-[120px] relative overflow-hidden"
      style={{
        background: "linear-gradient(245.45deg, #12A9D8 16%, #0C3245 100%)",
      }}
    >
      {ornament && ornament.data && (
        <Image
          src={ornament.data?.attributes?.url}
          alt={ornament.data?.attributes?.alternativeText || ornament.data?.attributes?.name}
          width={ornament.data?.attributes?.width || 267}
          height={ornament.data?.attributes?.height || 225}
          className="w-[95px] sm:w-[160px] lg:w-[267px] h-[80px] sm:h-[160px] lg:h-[225px] absolute top-[-30px] sm:top-[-70px] lg:top-[-100px] -right-4 object-contain"
        />
      )}
      <div className="container relative">
        <SectionHeading className="text-center" title={title} description={description} descriptionClassName="sm:max-w-2xl mx-auto" />
        {list && list.length > 0 && (
          <div className="mt-14 md:mt-[72px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[48px] sm:gap-[40px] lg:gap-[60px]">
            {list.map((item, index) => {
              return <OurValueItem key={"our-value-item-" + index} {...item} />;
            })}
          </div>
        )}
      </div>
    </section>
  );
}
